import { observer } from 'mobx-react-lite'
import { type FC } from 'react'
import { Button, Dropdown, Divider, type IDropdownProps } from 'shared/ui'
import { type TeamsStore } from 'pages/settings/pages/teams/store/TeamsStore'
import styles from './styles.module.scss'

type IImportFromHubSpotDropdownProps = {
  teamsStore: TeamsStore
  className?: string
  dropdownProps?: IDropdownProps
}

export const ImportFromHubSpotDropdown: FC<IImportFromHubSpotDropdownProps> = observer(
  ({ teamsStore, className, dropdownProps }) => {
    const {
      importHubSpotDropdownItems,
      handleImportAllTeamsFromHubSpot,
      handleRefreshIntegrationTeamsData,
      handleImportIntegrationTeam,
      handleImportFromHubSpot,
      importingFromHubSpot,
      refreshingIntegrationTeamsData,
      showImportFromHubSpotAsSelect,
    } = teamsStore

    if (!showImportFromHubSpotAsSelect) {
      return (
        <Button
          text='Import from HubSpot'
          size='medium'
          contained='secondary'
          iconProps={{ icon: 'hubspot' }}
          className={className}
          onClick={handleImportFromHubSpot}
        />
      )
    }

    return (
      <Dropdown
        typeButton='button'
        placement='bottom-start'
        items={importHubSpotDropdownItems}
        withSearch
        placeholder='Search'
        maxHeight={200}
        disabled={importingFromHubSpot}
        onChange={(item) => handleImportIntegrationTeam(Number(item.id))}
        underControlComponent={(onCloseMenu) => (
          <>
            <Button
              text='Refresh data'
              size='small'
              typeBtn='informative'
              contained='secondary'
              className={styles.refreshDataButton}
              loading={refreshingIntegrationTeamsData}
              disabled={refreshingIntegrationTeamsData}
              onClick={handleRefreshIntegrationTeamsData}
            />
            <Button
              text='Import all teams'
              size='small'
              typeBtn='informative'
              contained='secondary'
              className={styles.importAllTeamsButton}
              onClick={() => handleImportAllTeamsFromHubSpot(onCloseMenu)}
            />
            <Divider sx={{ height: '1px', borderColor: 'var(--border-neutral-default)' }} />
          </>
        )}
        buttonProps={{
          text: importingFromHubSpot ? 'Importing from HubSpot...' : 'Import from HubSpot',
          size: 'medium',
          contained: 'secondary',
          iconProps: { icon: 'hubspot' },
          loading: importingFromHubSpot,
          disabled: importingFromHubSpot,
          className: styles.triggerButtonNowrap,
        }}
        className={className}
        ariaLabel='ImportFromHubSpot'
        {...dropdownProps}
      />
    )
  }
)
